$('document').ready(function () {
    $('[name="person[person_type]"]').on('change', function () {
        $('.legal, .physical').hide();
        $('.' + $(this).val()).show();
    }).trigger('change');
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-person-type.js